// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> creekside-village-dcb2
// Generated: 2026-11-03T21:34:40.154Z
// Counts: 1 design, 70 content, 42 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Creekside Village in Vancouver, WA, where spacious two and three-bedroom homes offer comfort in a vibrant community. Nestled near educational institutions like Clark College and Roosevelt Elementary, you'll find a rich tapestry of local culture and enriching opportunities just steps away. See what's around our community and explore local favorites!",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact the Creekside Village leasing team in Vancouver, WA to ask about availability, schedule a tour, or get help with your application. Call us or fill out the contact form and a leasing specialist will follow up.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "At Creekside Village in Vancouver, WA, you’ll find spacious two and three-bedroom homes surrounded by a vibrant educational landscape. With top-notch schools like Clark College and Roosevelt Elementary just minutes away, envision a life where learning and community thrive. Dive into the local fabric—uncover nearby parks, schools, and more!",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Creekside Village, the perfect blend of comfort, convenience, and modern living in the heart of Vancouver, WA. Our thoughtfully designed two and three-bedroom floor plans cater to a variety of lifestyles, ensuring you find the ideal space for your needs. Don’t wait! Find your new home today—browse our availability or schedule a tour to explore our beautiful community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Creekside Village in Vancouver, WA, our spacious two- and three-bedroom floor plans cater to your lifestyle needs. Experience the harmony of modern living surrounded by nature. Schedule a tour today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Creekside Village sits in Bagley Downs, just south of State Route 500 and between Interstates 5 and 205. Everyday stops stay close. Eleanor Roosevelt Elementary is on Falk Road in the neighborhood, Clark College is about two miles west, and WinCo on Andresen Road is about two miles east. Vancouver Mall is farther east along Fourth Plain Boulevard, the commercial strip at the south edge of the neighborhood.</p><p>Downtown Vancouver includes Esther Short Park, home of the Vancouver Farmers Market, the Vancouver Community Library, the Vancouver Waterfront, and the Amtrak station. Portland International Airport is to the east via I-205.</p><p>Downtown Portland is about eleven miles south on I-5, across the Interstate Bridge. C-TRAN’s Vine on Fourth Plain stops within about half a mile and runs between Vancouver Mall, Clark College, and downtown Vancouver. From downtown, weekday Route 105 continues express into downtown Portland, and Route 60 connects with TriMet’s MAX Yellow Line at the Expo Center in North Portland.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019fa525-2507-7183-9695-dcfe5d32b0cd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Person petting a tortoiseshell cat."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1e55-71ed-928f-1d4eb348618a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Creekside Village monument sign with landscaping in Vancouver, WA."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019fa526-b6b3-73bf-a863-074a6ef639d7.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "African American woman working out with dumbbells in an indoor setting, promoting a healthy lifestyle."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1a95-741b-9509-d97d839f1cdb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhomes with garages and manicured landscaping."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0208-717f-98af-659545b6b20b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and dining area with fireplace and large sectional sofa."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0e4b-755f-a717-960a697e1cea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept living and kitchen area with a fireplace and dining table."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019fa522-b051-761c-bd2f-a73122fb4625.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fit woman running on treadmill in gym wearing sports bra and earphones."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-01ca-75b6-b801-2bfee41d8033.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, ample cabinet space, and a large island with a sink."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0442-71cd-890c-04d3d3bff2a4.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0208-717f-98af-659545b6b20b.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-23f3-704e-af9c-3e7964b4beb5.webp"
      }
    }
  },
  "gallery.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166804/019d02d2-05e9-767d-80bb-2d435e95b37b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cyclist riding a paved path through a lush forest of tall evergreen trees."
      }
    }
  },
  "gallery.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166804/019d02d2-1100-7383-ae69-622c17120486.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A father and two young daughters smiling in a convertible on a sunny neighborhood street."
      }
    }
  },
  "gallery.lifestyle_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166804/019fa525-2507-7183-9695-dcfe5d32b0cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident gently petting a tortoiseshell cat at home."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1f2b-747a-b087-8f0bfc719255.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool at dusk with apartment buildings in the background."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-cc3a-76b2-a92f-c096a6f37880.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with garages and trees."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019fa523-6d75-7349-ba43-edab3558fefd.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A happy dog enjoys human interaction on a sunny day in Villahermosa, Mexico."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1912-761f-8f2d-e5fa877da0fe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Townhomes with garages and cars parked in front under trees."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-990d-777d-9363-ed8ffabde691.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartment buildings with garages and mature trees at Creekside Village in Vancouver, WA."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0c483-e256-76b8-b80a-48824f43d31d.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Adorable Jack Russell Terrier on a leash during a sidewalk stroll in Llanes, Spain."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019fa522-b051-761c-bd2f-a73122fb4625.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman running on a treadmill in the gym"
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1e55-71ed-928f-1d4eb348618a.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1444-72da-b641-bdba072851c0.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1eea-705e-8e1e-f720eb271681.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-141f-74ff-b624-a2cff61bc544.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-d315-732e-837f-afcc00c3d4a0.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-6376-7090-bf62-6274f0d1e8e7.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-343a-701a-8227-75af8e40e6b6.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-606b-75cb-82f6-9b0dc011292e.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-412e-732d-abc3-d70c96032335.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident package lockers with a mountain landscape mural at the entrance to Creekside Village in Vancouver, WA."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166804/019d02d2-1100-7383-ae69-622c17120486.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A man and two girls in a convertible, with houses in the background."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-c47a-7563-953e-7c96087ee8e0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings with a central outdoor swimming pool and surrounding trees."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-990d-777d-9363-ed8ffabde691.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartment buildings with garages and mature trees at Creekside Village in Vancouver, WA."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166804/019d02d2-1100-7383-ae69-622c17120486.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A man and two children smiling in a convertible outside the homes at Creekside Village in Vancouver, WA."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1eea-705e-8e1e-f720eb271681.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern communal lounge area with a fireplace, large TV, leather couch, and bar seating."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "custom_df34f2a5-ecf2-44f1-9074-2d36e5f9551d",
      "custom_c6161bd8-20c9-4176-9356-ea3b14f0c5cc",
      "custom_c2e272e8-7ecb-4525-96f3-6e71cce1c430",
      "custom_cb46003c-1579-4c99-b732-f7ea897f97eb",
      "custom_8e72c860-22e4-4029-b213-9fe7d862ae4a",
      "custom_78e19147-c895-447f-a31d-cb755451fd75",
      "custom_2bc436fd-03c8-49ba-aa84-858fe9b60ebb",
      "custom_644fb53b-f479-4216-9aca-110855813ec0",
      "custom_236742f9-4e94-43c2-a4b7-1a84dda8fc20",
      "custom_ed5b8e21-1085-4630-bbae-8e661537a352",
      "custom_73733dfa-b28b-4b0a-912d-015618efcddd",
      "custom_d0c26ea3-b195-4173-b275-e70aaf4230de",
      "custom_be2d80ac-beec-4a93-8fcf-d36edecc038f",
      "custom_373fb7ea-30a1-4fcb-9116-160e9756a2d5",
      "custom_91b794d6-465f-4b03-9af6-f0b02d60a7b7",
      "custom_60efae10-8752-459e-b4d6-fae7f93de951",
      "custom_d4b51245-6fd1-4da1-affc-53b86a832ac0",
      "custom_0e40a842-b476-4b65-b941-dd53893ff693",
      "custom_44bb42a2-0881-4123-97d8-0667525e1e6c",
      "custom_c4ecd32d-70e6-4bb8-a8a5-d7995d8b1cb3",
      "custom_a6149327-b08f-4f2e-b904-188be745d959",
      "custom_158ccf37-686c-4339-b7db-52277c45119e",
      "custom_81ca28ea-6ae9-443c-9155-00325a175323",
      "custom_67522331-a0a3-476a-a52c-530436795313",
      "custom_909bcc1a-48a7-4158-83db-d56bfcf51a17",
      "custom_3a4c9e5a-d256-49e0-bd5a-4b2d69ff61d7",
      "custom_7e25c97a-02c3-42c5-817f-21db40f1ed2c",
      "custom_1113f1ba-8ba0-4d8c-9530-777df5050966",
      "custom_6d188f18-f375-4759-8449-953220e6393d",
      "custom_900cf318-4206-4a48-9bff-f8c43f098eb1",
      "custom_d0dca1a3-3d90-4977-b82b-ae84dca8c32e",
      "custom_5ce043ac-7a7b-4421-83f6-fea3afeeb407",
      "custom_3bca14a5-0217-4b21-8e81-84e3dcf3947c",
      "custom_1770760d-2310-44ce-b8a1-32fc75ab1406",
      "custom_384daf85-c33e-4fde-bde5-a22548b56f3c",
      "custom_8d58bbad-1dbb-41c1-b1e2-fe48d4aa10e1",
      "custom_c933662c-4214-471f-a8ff-2c27d9e688bd",
      "custom_c91446ce-1044-42cf-ae10-75f2cda60404",
      "custom_e8354c44-1c08-43b3-bab0-886914e37348",
      "custom_47752e82-fa16-43d7-8aba-4c42ed0c467e",
      "custom_9094167d-e55d-4e52-a130-cd157e18451e",
      "custom_5d65f4d5-81fd-4d2e-bc4a-2e9931d5df18",
      "custom_df731042-8929-406c-bf2f-0ed0873d677c",
      "custom_69575959-dc5a-448f-ada6-1aaeb2a38ebc",
      "custom_92b77b58-eb76-4428-8601-e44bdc56f4bc",
      "custom_86ff9163-ba64-4d96-83a0-0d06c0108471",
      "custom_b2861499-dcb8-46e3-b6cf-94847c5bbde8",
      "custom_940db6bd-8ed9-43ef-82e1-ee940065a5ef",
      "custom_60ff2504-a1b1-4d60-9961-daecef2ac0b4",
      "custom_42e7f6a0-b9e2-4a6a-943e-265c76423500",
      "custom_0f2bf1ff-819d-4369-8343-f55001638b33",
      "custom_4ab83d9c-0139-4b1c-8e9f-2b9af0f9e062",
      "custom_34c2546d-0736-4cf1-af75-14f767b7f87b",
      "custom_90eb2f8e-6f26-4860-8527-65f2c2ae8fa9",
      "custom_3c84337e-5810-447e-8d41-8e7d7aec955b",
      "custom_81d72827-f9de-4218-a913-d04138629ac1",
      "custom_e0fcbd52-b8d3-4aa1-9c54-7a94f9357f21",
      "custom_01ca34ed-cd31-47fc-99bb-44900cfdf685",
      "custom_2c10e647-7da1-408e-98fb-02325ff08932",
      "custom_2d676947-17f4-498c-bcce-fa2dc904497e",
      "custom_0eaa76c8-5a4a-4575-845b-8ee83f925c5a",
      "custom_d1ba7eee-b3c8-49a6-af13-eaba30f5eed0",
      "custom_8f1470bc-c2e8-4630-8c75-3f80612ec5ea",
      "custom_b887ce67-b11f-4e4e-b2d1-a087c10dcdf4",
      "custom_3bf0d0e3-28ba-40ef-8e33-c469adc99777",
      "custom_cbfc6bf5-da96-4916-b26f-3454b03e696c",
      "custom_7b9337ac-d468-487e-9ac0-e9ed24397689",
      "custom_abcc6254-d5a0-4b5d-8e26-fd8838bbf103",
      "custom_88ad5540-ece3-4ab3-9795-c82ef3e6d2f8",
      "custom_228866a7-fcae-4e2f-9e96-8c138e7befdd",
      "custom_c5d61c27-984d-4dd7-bbc1-4affa1cd90e9",
      "custom_6b5d5829-e509-4c1c-b92c-491cdd0f2c78",
      "custom_9411d405-7208-4202-ae14-b26029c16aef",
      "custom_f8222782-41d8-4fb2-a52e-1821dfad9223",
      "custom_e432f1c1-9cc0-4199-849e-49a7265b62a3",
      "custom_2bfacf32-52af-4ea6-97e9-4da822862eb0",
      "custom_7cc62845-ea3c-4172-b7f9-5ce3b2db9f64",
      "custom_85beeebd-b943-4902-af83-dd3fef2a2ac0",
      "custom_9c7227f4-b661-4fd6-ada2-33d6574c8523",
      "custom_4b6396a8-3e6b-4506-a8b8-3b47b7c9ef97",
      "custom_796191d5-964b-469b-bbc7-31f5e4d243b7",
      "custom_cc8b8b97-5848-45da-a349-09bf7ad715b7",
      "custom_f46e31cb-af67-4a63-83a6-b7cdc647459d",
      "custom_d7a3c3c4-4518-44da-81e3-310b12c083de",
      "custom_dce691a0-1737-44d9-b0a1-e17013c48b17",
      "custom_f41c14d5-a289-4ff9-916e-8770b4d019fc"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_67522331-a0a3-476a-a52c-530436795313",
      "custom_236742f9-4e94-43c2-a4b7-1a84dda8fc20",
      "custom_d0c26ea3-b195-4173-b275-e70aaf4230de",
      "custom_373fb7ea-30a1-4fcb-9116-160e9756a2d5",
      "custom_ed5b8e21-1085-4630-bbae-8e661537a352",
      "custom_df731042-8929-406c-bf2f-0ed0873d677c",
      "custom_1113f1ba-8ba0-4d8c-9530-777df5050966",
      "custom_6d188f18-f375-4759-8449-953220e6393d",
      "custom_0e40a842-b476-4b65-b941-dd53893ff693",
      "custom_73733dfa-b28b-4b0a-912d-015618efcddd",
      "custom_a6149327-b08f-4f2e-b904-188be745d959",
      "custom_d4b51245-6fd1-4da1-affc-53b86a832ac0",
      "custom_be2d80ac-beec-4a93-8fcf-d36edecc038f",
      "custom_81ca28ea-6ae9-443c-9155-00325a175323",
      "custom_60efae10-8752-459e-b4d6-fae7f93de951",
      "custom_91b794d6-465f-4b03-9af6-f0b02d60a7b7",
      "custom_5ce043ac-7a7b-4421-83f6-fea3afeeb407",
      "custom_3bca14a5-0217-4b21-8e81-84e3dcf3947c",
      "custom_9094167d-e55d-4e52-a130-cd157e18451e",
      "custom_5d65f4d5-81fd-4d2e-bc4a-2e9931d5df18",
      "custom_69575959-dc5a-448f-ada6-1aaeb2a38ebc",
      "custom_86ff9163-ba64-4d96-83a0-0d06c0108471",
      "custom_b2861499-dcb8-46e3-b6cf-94847c5bbde8",
      "custom_60ff2504-a1b1-4d60-9961-daecef2ac0b4",
      "custom_34c2546d-0736-4cf1-af75-14f767b7f87b",
      "custom_01ca34ed-cd31-47fc-99bb-44900cfdf685",
      "custom_e95835d1-2fb9-421e-88f3-a2b97e4dcf9c",
      "custom_3bf0d0e3-28ba-40ef-8e33-c469adc99777",
      "custom_7b9337ac-d468-487e-9ac0-e9ed24397689",
      "custom_abcc6254-d5a0-4b5d-8e26-fd8838bbf103",
      "custom_0483c185-cba5-4b4e-bf81-7a2b05dc6892",
      "custom_228866a7-fcae-4e2f-9e96-8c138e7befdd",
      "custom_1a762542-0b7a-4a6a-9970-7f6791bab9b9",
      "custom_3b1ce724-42bc-48e0-9a89-1ee34068f5ce",
      "custom_9411d405-7208-4202-ae14-b26029c16aef",
      "custom_2bfacf32-52af-4ea6-97e9-4da822862eb0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_1770760d-2310-44ce-b8a1-32fc75ab1406",
      "custom_158ccf37-686c-4339-b7db-52277c45119e",
      "custom_2c10e647-7da1-408e-98fb-02325ff08932",
      "custom_3a4c9e5a-d256-49e0-bd5a-4b2d69ff61d7",
      "custom_909bcc1a-48a7-4158-83db-d56bfcf51a17",
      "custom_7e25c97a-02c3-42c5-817f-21db40f1ed2c",
      "custom_e8354c44-1c08-43b3-bab0-886914e37348",
      "custom_47752e82-fa16-43d7-8aba-4c42ed0c467e",
      "custom_940db6bd-8ed9-43ef-82e1-ee940065a5ef",
      "custom_44bb42a2-0881-4123-97d8-0667525e1e6c",
      "custom_c4ecd32d-70e6-4bb8-a8a5-d7995d8b1cb3",
      "custom_900cf318-4206-4a48-9bff-f8c43f098eb1",
      "custom_d0dca1a3-3d90-4977-b82b-ae84dca8c32e",
      "custom_384daf85-c33e-4fde-bde5-a22548b56f3c",
      "custom_8d58bbad-1dbb-41c1-b1e2-fe48d4aa10e1",
      "custom_c933662c-4214-471f-a8ff-2c27d9e688bd",
      "custom_98680d05-8fbc-4d94-884f-daa07e9fd5d1",
      "custom_c91446ce-1044-42cf-ae10-75f2cda60404",
      "custom_92b77b58-eb76-4428-8601-e44bdc56f4bc",
      "custom_54b0d824-c122-4518-8377-8fd8f5be608b",
      "custom_42e7f6a0-b9e2-4a6a-943e-265c76423500",
      "custom_0f2bf1ff-819d-4369-8343-f55001638b33",
      "custom_4ab83d9c-0139-4b1c-8e9f-2b9af0f9e062",
      "custom_90eb2f8e-6f26-4860-8527-65f2c2ae8fa9",
      "custom_6bd07e7c-8b94-4389-8dd1-abae473acaa5",
      "custom_3c84337e-5810-447e-8d41-8e7d7aec955b",
      "custom_81d72827-f9de-4218-a913-d04138629ac1",
      "custom_e0fcbd52-b8d3-4aa1-9c54-7a94f9357f21",
      "custom_2d676947-17f4-498c-bcce-fa2dc904497e",
      "custom_0eaa76c8-5a4a-4575-845b-8ee83f925c5a",
      "custom_22c81678-74bb-4e85-8f8d-afd3733f9ddf",
      "custom_d1ba7eee-b3c8-49a6-af13-eaba30f5eed0",
      "custom_8f1470bc-c2e8-4630-8c75-3f80612ec5ea",
      "custom_b887ce67-b11f-4e4e-b2d1-a087c10dcdf4",
      "custom_cbfc6bf5-da96-4916-b26f-3454b03e696c",
      "custom_c5d61c27-984d-4dd7-bbc1-4affa1cd90e9",
      "custom_6b5d5829-e509-4c1c-b92c-491cdd0f2c78",
      "custom_88ad5540-ece3-4ab3-9795-c82ef3e6d2f8",
      "custom_f8222782-41d8-4fb2-a52e-1821dfad9223",
      "custom_e432f1c1-9cc0-4199-849e-49a7265b62a3",
      "custom_8805b2bf-e6f9-435a-903a-b2d6fda3f3aa"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_236742f9-4e94-43c2-a4b7-1a84dda8fc20",
      "custom_2bfacf32-52af-4ea6-97e9-4da822862eb0",
      "custom_5d65f4d5-81fd-4d2e-bc4a-2e9931d5df18",
      "custom_67522331-a0a3-476a-a52c-530436795313",
      "custom_be2d80ac-beec-4a93-8fcf-d36edecc038f",
      "custom_d0c26ea3-b195-4173-b275-e70aaf4230de",
      "custom_b2861499-dcb8-46e3-b6cf-94847c5bbde8",
      "custom_86ff9163-ba64-4d96-83a0-0d06c0108471",
      "custom_373fb7ea-30a1-4fcb-9116-160e9756a2d5",
      "custom_ed5b8e21-1085-4630-bbae-8e661537a352",
      "custom_69575959-dc5a-448f-ada6-1aaeb2a38ebc",
      "custom_3bca14a5-0217-4b21-8e81-84e3dcf3947c",
      "custom_73733dfa-b28b-4b0a-912d-015618efcddd",
      "custom_9411d405-7208-4202-ae14-b26029c16aef",
      "custom_60ff2504-a1b1-4d60-9961-daecef2ac0b4",
      "custom_a6149327-b08f-4f2e-b904-188be745d959",
      "custom_0e40a842-b476-4b65-b941-dd53893ff693",
      "custom_34c2546d-0736-4cf1-af75-14f767b7f87b",
      "custom_7b9337ac-d468-487e-9ac0-e9ed24397689",
      "custom_abcc6254-d5a0-4b5d-8e26-fd8838bbf103",
      "custom_91b794d6-465f-4b03-9af6-f0b02d60a7b7",
      "custom_228866a7-fcae-4e2f-9e96-8c138e7befdd",
      "custom_01ca34ed-cd31-47fc-99bb-44900cfdf685",
      "custom_3bf0d0e3-28ba-40ef-8e33-c469adc99777",
      "custom_df731042-8929-406c-bf2f-0ed0873d677c",
      "custom_d4b51245-6fd1-4da1-affc-53b86a832ac0",
      "custom_5ce043ac-7a7b-4421-83f6-fea3afeeb407",
      "custom_9094167d-e55d-4e52-a130-cd157e18451e",
      "custom_81ca28ea-6ae9-443c-9155-00325a175323",
      "custom_60efae10-8752-459e-b4d6-fae7f93de951",
      "custom_1113f1ba-8ba0-4d8c-9530-777df5050966",
      "custom_f41c14d5-a289-4ff9-916e-8770b4d019fc",
      "custom_dce691a0-1737-44d9-b0a1-e17013c48b17",
      "custom_42e7f6a0-b9e2-4a6a-943e-265c76423500",
      "custom_3c84337e-5810-447e-8d41-8e7d7aec955b",
      "custom_81d72827-f9de-4218-a913-d04138629ac1",
      "custom_d1ba7eee-b3c8-49a6-af13-eaba30f5eed0",
      "custom_0f2bf1ff-819d-4369-8343-f55001638b33",
      "custom_4ab83d9c-0139-4b1c-8e9f-2b9af0f9e062",
      "custom_6b5d5829-e509-4c1c-b92c-491cdd0f2c78",
      "custom_2d676947-17f4-498c-bcce-fa2dc904497e",
      "custom_90eb2f8e-6f26-4860-8527-65f2c2ae8fa9",
      "custom_796191d5-964b-469b-bbc7-31f5e4d243b7",
      "custom_cc8b8b97-5848-45da-a349-09bf7ad715b7",
      "custom_f46e31cb-af67-4a63-83a6-b7cdc647459d",
      "custom_900cf318-4206-4a48-9bff-f8c43f098eb1"
    ],
    "orderedIds": [
      "custom_44bb42a2-0881-4123-97d8-0667525e1e6c",
      "custom_f8222782-41d8-4fb2-a52e-1821dfad9223",
      "custom_88ad5540-ece3-4ab3-9795-c82ef3e6d2f8",
      "custom_c933662c-4214-471f-a8ff-2c27d9e688bd",
      "custom_c91446ce-1044-42cf-ae10-75f2cda60404",
      "custom_8f1470bc-c2e8-4630-8c75-3f80612ec5ea",
      "custom_900cf318-4206-4a48-9bff-f8c43f098eb1",
      "custom_384daf85-c33e-4fde-bde5-a22548b56f3c",
      "custom_d0dca1a3-3d90-4977-b82b-ae84dca8c32e",
      "custom_c4ecd32d-70e6-4bb8-a8a5-d7995d8b1cb3",
      "custom_c5d61c27-984d-4dd7-bbc1-4affa1cd90e9",
      "custom_1770760d-2310-44ce-b8a1-32fc75ab1406",
      "custom_e432f1c1-9cc0-4199-849e-49a7265b62a3",
      "custom_47752e82-fa16-43d7-8aba-4c42ed0c467e",
      "custom_6b5d5829-e509-4c1c-b92c-491cdd0f2c78",
      "custom_4ab83d9c-0139-4b1c-8e9f-2b9af0f9e062",
      "custom_2d676947-17f4-498c-bcce-fa2dc904497e",
      "custom_940db6bd-8ed9-43ef-82e1-ee940065a5ef",
      "custom_3a4c9e5a-d256-49e0-bd5a-4b2d69ff61d7",
      "custom_e8354c44-1c08-43b3-bab0-886914e37348",
      "custom_158ccf37-686c-4339-b7db-52277c45119e",
      "custom_8d58bbad-1dbb-41c1-b1e2-fe48d4aa10e1",
      "custom_0eaa76c8-5a4a-4575-845b-8ee83f925c5a",
      "custom_90eb2f8e-6f26-4860-8527-65f2c2ae8fa9",
      "custom_909bcc1a-48a7-4158-83db-d56bfcf51a17",
      "custom_7e25c97a-02c3-42c5-817f-21db40f1ed2c",
      "custom_2c10e647-7da1-408e-98fb-02325ff08932",
      "custom_e0fcbd52-b8d3-4aa1-9c54-7a94f9357f21",
      "custom_b887ce67-b11f-4e4e-b2d1-a087c10dcdf4",
      "custom_cbfc6bf5-da96-4916-b26f-3454b03e696c",
      "custom_d1ba7eee-b3c8-49a6-af13-eaba30f5eed0",
      "custom_0f2bf1ff-819d-4369-8343-f55001638b33",
      "custom_81d72827-f9de-4218-a913-d04138629ac1",
      "custom_3c84337e-5810-447e-8d41-8e7d7aec955b",
      "custom_42e7f6a0-b9e2-4a6a-943e-265c76423500",
      "custom_236742f9-4e94-43c2-a4b7-1a84dda8fc20",
      "custom_5d65f4d5-81fd-4d2e-bc4a-2e9931d5df18",
      "custom_67522331-a0a3-476a-a52c-530436795313",
      "custom_2bfacf32-52af-4ea6-97e9-4da822862eb0",
      "custom_be2d80ac-beec-4a93-8fcf-d36edecc038f",
      "custom_d0c26ea3-b195-4173-b275-e70aaf4230de",
      "custom_b2861499-dcb8-46e3-b6cf-94847c5bbde8",
      "custom_ed5b8e21-1085-4630-bbae-8e661537a352",
      "custom_373fb7ea-30a1-4fcb-9116-160e9756a2d5",
      "custom_86ff9163-ba64-4d96-83a0-0d06c0108471",
      "custom_69575959-dc5a-448f-ada6-1aaeb2a38ebc",
      "custom_3bca14a5-0217-4b21-8e81-84e3dcf3947c",
      "custom_73733dfa-b28b-4b0a-912d-015618efcddd",
      "custom_a6149327-b08f-4f2e-b904-188be745d959",
      "custom_60ff2504-a1b1-4d60-9961-daecef2ac0b4",
      "custom_9411d405-7208-4202-ae14-b26029c16aef",
      "custom_0e40a842-b476-4b65-b941-dd53893ff693",
      "custom_34c2546d-0736-4cf1-af75-14f767b7f87b",
      "custom_7b9337ac-d468-487e-9ac0-e9ed24397689",
      "custom_228866a7-fcae-4e2f-9e96-8c138e7befdd",
      "custom_91b794d6-465f-4b03-9af6-f0b02d60a7b7",
      "custom_abcc6254-d5a0-4b5d-8e26-fd8838bbf103",
      "custom_01ca34ed-cd31-47fc-99bb-44900cfdf685",
      "custom_3bf0d0e3-28ba-40ef-8e33-c469adc99777",
      "custom_df731042-8929-406c-bf2f-0ed0873d677c",
      "custom_9094167d-e55d-4e52-a130-cd157e18451e",
      "custom_5ce043ac-7a7b-4421-83f6-fea3afeeb407",
      "custom_d4b51245-6fd1-4da1-affc-53b86a832ac0",
      "custom_81ca28ea-6ae9-443c-9155-00325a175323",
      "custom_60efae10-8752-459e-b4d6-fae7f93de951",
      "custom_1113f1ba-8ba0-4d8c-9530-777df5050966",
      "custom_644fb53b-f479-4216-9aca-110855813ec0",
      "custom_d7a3c3c4-4518-44da-81e3-310b12c083de",
      "custom_9c7227f4-b661-4fd6-ada2-33d6574c8523",
      "custom_8e72c860-22e4-4029-b213-9fe7d862ae4a",
      "custom_c2e272e8-7ecb-4525-96f3-6e71cce1c430",
      "custom_2bc436fd-03c8-49ba-aa84-858fe9b60ebb",
      "custom_78e19147-c895-447f-a31d-cb755451fd75",
      "custom_cb46003c-1579-4c99-b732-f7ea897f97eb",
      "custom_7cc62845-ea3c-4172-b7f9-5ce3b2db9f64",
      "custom_df34f2a5-ecf2-44f1-9074-2d36e5f9551d",
      "custom_c6161bd8-20c9-4176-9356-ea3b14f0c5cc",
      "custom_4b6396a8-3e6b-4506-a8b8-3b47b7c9ef97",
      "custom_85beeebd-b943-4902-af83-dd3fef2a2ac0",
      "custom_6d188f18-f375-4759-8449-953220e6393d",
      "custom_92b77b58-eb76-4428-8601-e44bdc56f4bc",
      "custom_dce691a0-1737-44d9-b0a1-e17013c48b17",
      "custom_796191d5-964b-469b-bbc7-31f5e4d243b7",
      "custom_cc8b8b97-5848-45da-a349-09bf7ad715b7",
      "custom_f41c14d5-a289-4ff9-916e-8770b4d019fc",
      "custom_f46e31cb-af67-4a63-83a6-b7cdc647459d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
